import {JsonAny} from "../../Types";
import {parseISO} from "date-fns";

export interface VideoExtraMaterial {
    id: number;
    videoId: number;
    fileName: string;
    contentType: string;
    fileSizeBytes: number;
    created: Date;
}

export function parseVideoExtraMaterial(json: JsonAny): VideoExtraMaterial {
    return {
        ...json,
        created: parseISO(json.created)
    };
}
